import { createContext, useContext } from "react";

interface TreeContextType {
  checkIfGamePieceNameIsValid: (name: string) => boolean;
}

interface TreeWriteContextType {
  onTryRenameGamePiece: (oldName: string, newName: string) => void;
}

export const TreeContext = createContext<TreeContextType>({
  checkIfGamePieceNameIsValid: (name: string) => {
    return false;
  },
});

export const TreeWriteContext = createContext<TreeWriteContextType>({
  onTryRenameGamePiece: (oldName: string, newName: string) => {},
});

export const useTreeContext = () => useContext<TreeContextType>(TreeContext);
export const useTreeWriteContext = () => useContext<TreeWriteContextType>(TreeWriteContext);
